import { alpha } from '@mui/material/styles';

export const isSkillEnabled = (skill) => !!skill && skill.enabled !== false;

export const selectableSkills = (skills, ...keepIds) => {
    const keep = keepIds.map((id) => (id ? String(id._id || id) : null)).filter(Boolean);
    return (skills || []).filter((skill) => isSkillEnabled(skill) || keep.includes(String(skill._id)));
};

export const skillOptionLabel = (skill) => (isSkillEnabled(skill) ? skill.name : `${skill.name} (disabled)`);

// Legacy records hold [] where newer ones hold null; both mean no skill.
export const hasSkill = (item) => (Array.isArray(item?.skill) ? item.skill.length > 0 : !!item?.skill);

export const missingSkillHighlight = (theme) => ({
    background: `linear-gradient(90deg, ${alpha(theme.palette.warning.main, 0.14)} 0%, ${alpha(theme.palette.warning.main, 0.05)} 45%, transparent 100%)`,
    boxShadow: `inset 3px 0 0 ${alpha(theme.palette.warning.main, 0.55)}`,
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0, -1),
    padding: theme.spacing(1, 1.5),
});
